import { render, staticRenderFns } from "./IndexPage.vue?vue&type=template&id=298cd658&"
import script from "./IndexPage.vue?vue&type=script&lang=ts&"
export * from "./IndexPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('298cd658')) {
      api.createRecord('298cd658', component.options)
    } else {
      api.reload('298cd658', component.options)
    }
    module.hot.accept("./IndexPage.vue?vue&type=template&id=298cd658&", function () {
      api.rerender('298cd658', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/open-close-period/yearly/IndexPage.vue"
export default component.exports